import { Footer } from "~/components/Footer"
import { NavBar } from "~/components/NavBar"
import type { FCWithChildren } from "~/types/react"

export const NoExtraStyleLayout: FCWithChildren = ({ children }) => {
  return (
    <>
      <NavBar />
      <main>{children}</main>
      <Footer />
    </>
  )
}
